import {
  fieldComponents,
  NumberCalculatorComponent as Number
} from '@elfsight/widget-form-builder/widget';

export const calculatorFieldComponents = {
  ...fieldComponents,
  number: Number
};
